// extracted by mini-css-extract-plugin
var _1 = "RGfQQr1T";
var _2 = "WlWhkQV6";
var _3 = "HO0CyxpS";
export { _1 as "block", _2 as "circle", _3 as "label" }
